export default "__VITE_ASSET__vLrFgdfU__"